import styled from 'styled-components'

export const ModalBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  width: 100%;
  align-self: stretch;
  min-width: 0;
`

export const FilterRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 1.2rem;
  width: 100%;
  padding: 0 0.25rem;
`

export const FilterLabel = styled.span`
  color: #a8a8a8;
  font-size: 1.3rem;
  font-weight: 600;
  white-space: nowrap;
`

export const RangeSelectWrapper = styled.div`
  position: relative;
  flex: 1;
  max-width: 240px;
`

export const RangeSelectIcon = styled.span`
  position: absolute;
  top: 50%;
  right: 0.75rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #78bc28;
  pointer-events: none;
  transform: translateY(-50%);
`

export const RangeSelect = styled.select`
  width: 100%;
  padding: 0.55rem 2rem 0.55rem 0.95rem;
  border: 1px solid #3a3a3a;
  border-radius: 999px;
  background-color: rgba(255, 255, 255, 0.04);
  color: #f0f0f0;
  font-family: 'Chivo', sans-serif;
  font-size: 1.3rem;
  cursor: pointer;
  appearance: none;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;

  &:focus {
    outline: none;
    border-color: rgba(120, 188, 40, 0.65);
    box-shadow: 0 0 0 1px rgba(120, 188, 40, 0.15);
  }

  option {
    background: #111;
    color: #f0f0f0;
  }
`

export const RoundsList = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 0.65rem;
  height: 570px;
  max-height: 570px;
  min-height: 0;
  flex-shrink: 0;
  overflow-y: scroll;
  overflow-x: hidden;
  padding-right: 0.35rem;
  -webkit-overflow-scrolling: touch;
  overscroll-behavior: contain;

  & > * {
    flex-shrink: 0;
  }

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background: rgba(255, 255, 255, 0.04);
    border-radius: 999px;
  }

  &::-webkit-scrollbar-thumb {
    background: #444;
    border-radius: 999px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #666;
  }
`

export const RoundCard = styled.article`
  flex-shrink: 0;
  border-radius: 12px;
  border: 1px solid ${({ $variant }) =>
    $variant === 'win'
      ? 'rgba(119, 188, 40, 0.6)'
      : $variant === 'lose'
        ? 'rgba(220, 53, 69, 0.6)'
        : '#2a2a2a'};
  overflow: hidden;
`

export const TransactionsPanel = styled.div`
  border-top: 1px solid #2a2a2a;
  padding: 0.65rem 0.75rem 1.1rem;
  background: rgba(0, 0, 0, 0.25);
  border-radius: 0 0 12px 12px;
  animation: historyPanelIn 0.2s ease;

  @keyframes historyPanelIn {
    from {
      opacity: 0;
      transform: translateY(-4px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
`

export const RoundHeader = styled.button`
  display: flex;
  align-items: stretch;
  gap: 0.85rem;
  width: 100%;
  padding: 0.85rem;
  border: 0;
  background: transparent;
  cursor: pointer;
  text-align: left;
  color: inherit;
`

export const GameThumb = styled.img`
  width: 64px;
  height: 64px;
  flex-shrink: 0;
  border-radius: 10px;
  object-fit: cover;
  border: 1px solid #333;
`

export const RoundInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
  flex: 1;
  min-width: 0;
`

export const RoundMeta = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
  font-size: 1rem;
  color: #888;
`

export const RoundId = styled.span`
  color: #aaa;
  font-weight: 600;
`

export const RoundDate = styled.span`
  white-space: nowrap;
`

export const RoundStats = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem 1rem;
  font-size: 1.25rem;
  color: #e4e4e4;
`

export const StatValue = styled.strong`
  color: ${({ $variant }) =>
    $variant === 'win' ? '#78bc28' : $variant === 'lose' ? '#e74c5c' : '#999'};
  font-weight: 700;
`

export const ExpandIcon = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  align-self: center;
  color: #939292;
  transition: transform 0.2s ease, color 0.2s ease;
  transform: ${({ $expanded }) => ($expanded ? 'rotate(180deg)' : 'rotate(0)')};

  ${RoundHeader}:hover & {
    color: #78bc28;
  }
`

export const TransactionRow = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto auto;
  gap: 0.5rem 0.75rem;
  align-items: center;
  padding: 0.55rem 0;
  font-size: 0.95rem;
  color: #c8c7c7;
  border-bottom: 1px solid rgba(255, 255, 255, 0.04);
  line-height: 1.45;

  &:last-child {
    border-bottom: 0;
    padding-bottom: 0;
  }
`

export const TransactionAmount = styled.span`
  text-align: right;
  font-weight: 700;
  white-space: nowrap;
  color: ${({ $variant }) =>
    $variant === 'win' ? '#78bc28' : $variant === 'lose' ? '#e74c5c' : '#999'};
`

export const EmptyState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.75rem;
  padding: 2.5rem 1rem;
  color: #666;
  font-family: 'Chivo', sans-serif;
  font-size: 1.1rem;
  text-align: center;
`

export const LoadingMore = styled.div`
  display: flex;
  justify-content: center;
  padding: 0.75rem;
  color: #78bc28;
`

export const Sentinel = styled.div`
  height: 1px;
  width: 100%;
`
